module.exports = __webpack_public_path__ + "img/hover-dots.ecfb2fa2.svg";